var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.955 0c-1.645 0-3 1.355-3 3v12c0 1.645 1.355 3 3 3h12c1.645 0 3-1.355 3-3V3c0-1.645-1.355-3-3-3zm0 2h12c.565 0 1 .435 1 1v12c0 .565-.435 1-1 1h-12c-.565 0-1-.435-1-1V3c0-.565.435-1 1-1m.701 2 3.941 5.633L4.861 14h1.332l3.002-3.516L11.652 14h3.84l-4.186-5.99L14.728 4h-1.31l-2.703 3.16L8.508 4zm1.865.988h1.487l5.63 8.024h-1.496z"
  })));
};
export default SvgX;